<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {CANDIDATES} from '../../../../Config/ScreeningAppUrl';
import {Candidate} from "@Views/Screening/utility/apiAgent";

export default {
  extends: CoreLibrary,
  name: "CandidateList",
  mixins: [TableHelpers],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: CANDIDATES,
        showHeader: true,
        columns: [
          {
            title: this.$t("SR. No"),
            type: "text",
            key: "id"
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "full_name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },

          {
            title: this.$t("email"),
            type: "custom-html",
            key: "email",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Added To Screening"),
            type: "custom-html",
            key: "application_archive",
            modifier: (value, rowData) => {
              let date = value?.created_at??''
              if (date) date = moment(date).format("DD-MM-YYYY");

              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Status"),
            type: "custom-html",
            key: "application_archive",
            modifier: (value, rowData) => {
              let status = value?.archived_when??''
              return `<span>${this.$t(status)}</span>`;
            },
          },

          {
            title: this.$t("progress"),
            type: "custom-html",
            key: "completion_percentage",
            modifier: (value) => {
              return `<span>${value} %</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view_original_application"),
            icon: "file-plus",
            type: "none",
          },
          {
            title: this.$t("view_current_application"),
            icon: "file-plus",
            type: "none",
          },
          {
            title: this.$t("shortlist"),
            icon: "file-plus",
            type: "none",
          }
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    getPageTitle() {
      let pageTitle = 'Candidates For Screening';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("shortlist")) {
        this.shortlistCandidate(rowData.id);
      }
      if (actionObj.title == this.$t("view_current_application")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.id}`, '_blank');
      }
      if (actionObj.title == this.$t("view_original_application")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.id}?applicant_archive=${rowData.application_archive?.id}`, '_blank');
      }

    },
    shortlistCandidate(applicantId) {
      Candidate.shortListCandidate(applicantId)
          .then((response) => {
            this.$toastr.s(response.data.message);
          })
          .catch(({error}) => {
            //trigger after error
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    }
  }
};
</script>